const TabObj = {
    el: null,
    tablist: null,
    tabs: null,
    firstTab: null,
    lastTab: null,
    panelList: null,
    tabPanels: null,
    isDynamic: false,
    btnTemplate: null,
    panelTemplate: null
}

let div

export function CreateTabs(el) {
    if (!el) {
        return
    }

    div = document.createElement('div')

    let Obj = { ...TabObj }
    init.call(Obj, el)
    return Obj
}

function init(el) {
    this.el = el

    if (this.el.classList.contains('js-tab--dynamic-content')) {
        this.isDynamic = true
    }
    this.tablist = this.el.querySelector('[role=tablist]')

    if (!this.tablist) {
        return
    }

    this.tabs = Array.from(this.tablist.querySelectorAll('[role=tab]'))
    this.tabPanels = Array.from(this.el.querySelectorAll('[role=tabpanel]'))
    this.panelList = this.tabPanels[0].parentElement
    this.btnTemplate = this.el.querySelector('.js-tab-nav-btn')
    this.panelTemplate = this.el.querySelector('.js-tab-panel')

    this.firstTab = this.tabs[0]
    this.lastTab = this.tabs[this.tabs.length - 1]

    if (this.isDynamic) {
        setupDynamicTabs.call(this)
        this.tabs = Array.from(this.tablist.querySelectorAll('[role=tab]'))
        this.tabPanels = Array.from(this.el.querySelectorAll('[role=tabpanel]'))
    }

    this.tablist.addEventListener('keydown', onKeyDown.bind(this))
    this.tablist.addEventListener('click', onClick.bind(this))
    setSelectedTab.call(this, this.firstTab, false)
}

function setupDynamicTabs() {
    const contentEL = this.el.querySelector('.js-tab-content')
    const descriptionContent = contentEL.innerHTML
    let split = descriptionContent.split('>\n<h5')
    split = split.map((el, index) => {
        if (index < split.length - 1) {
            el = el + '>'
        }

        if (index > 0) {
            el = '<h5' + el
        }
        return el
    })

    split = split.filter((el) => el.includes('<h5'))

    const newPanels = split
        .map((tabContent) => {
            const titleMatch = tabContent.match(/(?:<h5[^>]+>|<h5>)(.+)(?:<\/h5>)/)
            const title = titleMatch[1]
            const content = tabContent.replace(titleMatch[0], '')
            const id = title
                .toLowerCase()
                .trim()
                .replace('&nbsp;', '')
                .replace(/[^a-z ]/, '')
                .replace(/\s/, '-')

            if (id === 'description') {
                contentEL.innerHTML = content
                return
            }

            return {
                title,
                content,
                id
            }
        })
        .filter(Boolean)

    newPanels.forEach(({ title, content, id }) => {
        const newNavItem = this.btnTemplate.innerHTML
            .replace(/{id}/g, id)
            .replace(/{label}/g, title)
        const newPanelItem = this.panelTemplate.innerHTML
            .replace(/{id}/g, id)
            .replace(/{content}/g, content)

        div.innerHTML = newNavItem
        this.tablist.appendChild(div.firstElementChild)

        div.innerHTML = newPanelItem
        this.panelList.appendChild(div.firstElementChild)
    })
}

function setSelectedTab(currentTab, setFocus = true) {
    this.tabs.forEach((tab, index) => {
        if (currentTab === tab) {
            tab.setAttribute('aria-selected', 'true')
            tab.removeAttribute('tabindex')
            this.tabPanels[index].classList.remove('is-hidden')
            if (setFocus) {
                tab.focus()
            }
        } else {
            tab.setAttribute('aria-selected', 'false')
            tab.tabIndex = -1
            this.tabPanels[index].classList.add('is-hidden')
        }
    })
}

function setSelectedToPreviousTab(currentTab) {
    if (currentTab === this.firstTab) {
        setSelectedTab.call(this, this.lastTab)
    } else {
        const index = this.tabs.indexOf(currentTab)
        setSelectedTab.call(this, this.tabs[index - 1])
    }
}

function setSelectedToNextTab(currentTab) {
    if (currentTab === this.lastTab) {
        setSelectedTab.call(this, this.firstTab)
    } else {
        const index = this.tabs.indexOf(currentTab)
        setSelectedTab.call(this, this.tabs[index + 1])
    }
}

function onKeyDown(evt) {
    if (evt.target.getAttribute('role') !== 'tab') {
        return
    }

    let stopFlag = false
    const target = evt.target
    switch (evt.key) {
        case 'ArrowLeft':
            setSelectedToPreviousTab.call(this, target)
            stopFlag = true
            break
        case 'ArrowRight':
            setSelectedToNextTab.call(this, target)
            stopFlag = true
            break
        case 'Home':
            setSelectedTab.call(this, this.firstTab)
            stopFlag = true
            break
        case 'End':
            setSelectedTab.call(this, this.lastTab)
            stopFlag = true
            break
    }

    if (stopFlag) {
        evt.stopPropagation()
        evt.preventDefault()
    }
}

function onClick(evt) {
    if (evt.target.getAttribute('role') !== 'tab') {
        return
    }

    setSelectedTab.call(this, evt.target)
}
